/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whatwedo_Subheading2Inputs */

const ja_careers_whatwedo_subheading2 = /** @type {(inputs: Careers_Whatwedo_Subheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームを通じて文化を創出`)
};

const en_careers_whatwedo_subheading2 = /** @type {(inputs: Careers_Whatwedo_Subheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We create and share game culture by :`)
};

/**
* | output |
* | --- |
* | "We create and share game culture by :" |
*
* @param {Careers_Whatwedo_Subheading2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whatwedo_subheading2 = /** @type {((inputs?: Careers_Whatwedo_Subheading2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whatwedo_Subheading2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whatwedo_subheading2(inputs)
	return en_careers_whatwedo_subheading2(inputs)
});
export { careers_whatwedo_subheading2 as "careers_whatWeDo_subheading" }